/**
 * Emit hosts for the `notification` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function trackNotificationPreferencesSavedFromModal({
  isSessionExpiringNotificationEnabled,
  isInmailNotificationEnabled,
}: {
  isSessionExpiringNotificationEnabled: boolean;
  isInmailNotificationEnabled: boolean;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.Notification,
    props: {
      action: SegmentActionName.NotificationPreferencesSavedFromModal,
      isSessionExpiringNotificationEnabled: isSessionExpiringNotificationEnabled,
      isInmailNotificationEnabled: isInmailNotificationEnabled,
    },
  });

  // V2 — notification_updated
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.NotificationUpdated,
    props: {
      update_action: 'preferences_saved_from_modal',
      is_session_expiring_notification_enabled: isSessionExpiringNotificationEnabled,
      is_inmail_notification_enabled: isInmailNotificationEnabled,
    },
  });
}
